export const RICH_TEXT_NAME = 'Rich Text';
